import React from 'react';
import { AlertTriangle, CalendarDays, Star } from 'lucide-react';
import { allergiesOf, FloorReservation } from '../../../utils/dineInReservations';

/**
 * Η κράτηση του τραπεζιού στο PDA (Xentrix Sala): ποιος κάθεται ή ποιος έρχεται,
 * με VIP και αλλεργίες μπροστά — ο σερβιτόρος τα βλέπει πριν πάρει παραγγελία.
 */
const ReservationStrip: React.FC<{ reservation: FloorReservation }> = ({ reservation: r }) => {
  const allergies = allergiesOf(r);
  const when = r.status === 'seated' ? 'Κράτηση' : `Κράτηση ${r.reservation_time.slice(0, 5)}`;
  return (
    <div data-testid="reservation-strip" className="mx-3 mt-3 rounded-2xl border border-blue-300 dark:border-blue-700/60 bg-blue-50 dark:bg-blue-900/25 px-3 py-2.5 space-y-1.5">
      <div className="flex items-center gap-2 min-w-0">
        <CalendarDays className="w-4 h-4 shrink-0 text-blue-600 dark:text-blue-400" />
        <span className="font-bold text-t1 truncate">{r.customer_name}</span>
        {r.guest_is_vip && <Star className="w-4 h-4 shrink-0 text-amber-500 fill-amber-400" aria-label="VIP" />}
        <span className="ml-auto shrink-0 text-sm text-t3 tabular-nums">{when} · {r.party_size} άτομα</span>
      </div>
      {allergies && (
        <p className="flex items-center gap-1.5 text-sm font-bold text-red-700 dark:text-red-300">
          <AlertTriangle className="w-4 h-4 shrink-0" />Αλλεργίες: {allergies}
        </p>
      )}
      {r.notes && <p className="text-sm text-t2">«{r.notes}»</p>}
    </div>
  );
};

export default ReservationStrip;
